export default __webpack_public_path__ + "static/when-christmas-start-2f8934d1d43eb5d2e676e72e23d0deb5.png";